import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import api from "@/api";
import { useStore } from "@/store/StoreContext";
import Seo from "@/components/store/Seo";
import ProductCard from "@/components/store/ProductCard";

export default function Wishlist() {
  const { user, authChecked } = useStore();
  const [items, setItems] = useState(null);
  const { wishlistIds } = useStore();
  useEffect(() => {
    if (!user) { setItems([]); return; }
    api.get("/auth/wishlist").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, [user, wishlistIds]);
  return (
    <div className="tq-container py-10 sm:py-14" data-testid="wishlist-page">
      <Seo title="Wishlist" noindex />
      <h1 className="font-serif text-3xl sm:text-5xl mb-8">Your Wishlist</h1>
      {!authChecked || items === null ? (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">{[...Array(4)].map((_, i) => <div key={i} className="aspect-[3/4] bg-[#FAFAFA] animate-pulse" />)}</div>
      ) : !user ? (
        <div className="text-center py-16" data-testid="wishlist-login-prompt">
          <Heart size={40} strokeWidth={1.2} className="mx-auto text-[#A8821B] mb-4" />
          <p className="font-serif text-2xl mb-4">Login to view your wishlist</p>
          <Link to="/account" className="tq-btn-dark">Login / Register</Link>
        </div>
      ) : items.length === 0 ? (
        <div className="text-center py-16" data-testid="wishlist-empty">
          <Heart size={40} strokeWidth={1.2} className="mx-auto text-[#A8821B] mb-4" />
          <p className="font-serif text-2xl mb-2">Nothing saved yet</p>
          <p className="text-sm text-[#666666] mb-6">Tap the heart on any pair you love.</p>
          <Link to="/collections/new-arrivals" className="tq-btn-dark">Explore Collection</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
          {items.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
